<template>
  <div
    class="details"
    :class="{ 'details--has-alert': aiAssistanceAlertVisible }">
    <div v-if="aiAssistanceAlertVisible" class="details__alert">
      <p>
        <span class="mi-24px mi-exclamation-triangle"></span>
        <span>
          This is an AI-assisted system. Outputs may be inaccurate—always review
          before acting. Not for autonomous decisions.
        </span>
      </p>
    </div>
    <!-- <notification
      type="error"
      icon="exclamation-triangle"
      title="Warning !"
      class="details__warning"
    >
      <p> Our System is getting upgraded, please note for S/4 Sealand Pilot countries “Belgium, Denmark, France, Germany, the Netherlands, Sweden, and the United Kingdom” Dispute View and GAM will be down from MAY 26th 18:00 CET- JUNE 2nd. Within this period all dispute related activities will be on hold and you might experience delay in dispute related services.</p>
    </notification> -->
    <div class="details-breadcrumb">
      <span class="details-breadcrumb--nav">
        <router-link to="/">Home</router-link>
      </span>
      <span class="details-breadcrumb--separator">/</span>
      <span class="details-breadcrumb--case-id">
        Dispute Id: {{ ohpDisputeId }}
      </span>
    </div>
    <div class="details-card">
      <div slot="content">
        <loading
          :active.sync="resolutionModalLoading"
          :can-cancel="false"
          :is-full-page="true"
          color="#0573ab" />
      </div>
      <dispute-grid-card
        v-if="Object.keys(caseDetails).length"
        :employee-id="user.employeeId"
        :item="caseDetails"
        :disputes-constants="disputesConstants"
        :is-details-mode="true"
        :resolution-rules-loading="resolutionRulesLoading"
        :dispute-lookup-fields="disputeLookupFields"
        :resolution-status-list="resolutionStatusList"
        :resolution-rules="resolutionRules"
        :dispute-chargecode-fields="disputeDisputeChargecodeFields"
        :resolution-stages-list="resolutionStagesList"
        :resolution-button-values="resolutionButtonValues"
        :next-status-drop-down-list="nextStatusDropDownList"
        :resolution-modal-loading="resolutionModalLoading"
        :is-s-l-a-missed="isSLAMissed"
        :reason-for-delay-options="reasonForDelayOptions"
        @updateCaseDetails="updateCaseDetails"
        @updateDisputes="updateDisputes"
        @disputeStatusUpdate="disputeStatusUpdate($event)"
        @updateVoiceDisputeData="updateVoiceDisputeData"
        @getCaseDetailsInfo="getCaseDetailsInfo"
        @getCaseDetailsStageStatusList="getCaseDetailsStageStatusList"
        @getCaseDetailsRulesList="getCaseDetailsRulesList"
        @fetchDisputeRecords="() => fetchDisputeDetails()"
        @fetchVoiceDisputes="fetchVoiceDisputes"
        @fetchDisputeComments="fetchDisputeComments"
        @isSLAMissedCheck="isSLAMissedCheck" />
      <dashboard-skeleton v-else />
    </div>
    <div class="details-invoice-breakup">
      <div
        class="details-invoice-breakup-dropdown"
        @click="handleInvoiceBreakupClick">
        <span class="details-invoice-breakup-dropdown-name">
          {{ isInvoiceDetailsVisible ? "Hide" : "Show" }} Invoice breakup
        </span>
        <span
          v-if="isInvoiceDetailsVisible"
          class="mi-20px mi-double-chevron-up"
          aria-hidden="true"></span>
        <span
          v-else
          class="mi-20px mi-double-chevron-down"
          aria-hidden="true"></span>
      </div>
      <div
        v-if="isInvoiceDetailsVisible"
        class="details-invoice-breakup-details">
        <span class="details-invoice-breakup-details-name">
          Invoice breakup
        </span>
        <span class="details-invoice-breakup-details-name">
          Total Base Amount {{ getInvoiceBaseAmount }} <br /><br />
          Total Payable Amount {{ getInvoicePayableAmount }}
        </span>
        <div
          class="details-invoice-breakup-details-table"
          :class="tableParentClass">
          <Table
            :default-columns="invoiceBreakupColumns"
            :row-data="invoiceBreakup"
            :primary-key="{ colKey: 'id', rowKey: 'invoiceNumber' }"
            cell-background="#fff"
            header-cell-background="#f7f7f7"
            no-data-message="Invoice breakup data is not present"
            @addParentClass="addParentClass" />
        </div>
      </div>
    </div>
    <div v-if="Object.keys(caseDetails).length" class="details-tab-area">
      <Tabs
        :items="detailsTabItemsList"
        type="overflow"
        @onClick="onTabActivated" />
    </div>
    <div
      v-if="Object.keys(caseDetails).length"
      ref="tabContainer"
      class="details-sub-tabs vld-parent">
      <dispute-comments
        v-if="currentSelectedTab === 'comments'"
        ref="disputeComments"
        :user="user"
        :comments="comments"
        :case-details="caseDetails"
        @fetchDisputeComments="fetchDisputeComments" />
      <dispute-case-information
        v-else-if="currentSelectedTab === 'case-information' && caseDetailsSfdc"
        ref="disputeCaseInformation"
        :case-details-sfdc="caseDetailsSfdc"
        :case-details="caseDetails"
        @fetchRelatedIsrFromSfdc="fetchRelatedIsrFromSfdc"
        @fetchISRDetails="fetchISRDetails"
        @fetchAttachmentsFromSfdc="fetchAttachmentsFromSfdc"
        @createIsr="createIsr"
        @updateIsr="updateIsr"
        @fetchEmailActivities="fetchEmailActivities"
        @getCountryList="getCountryList" />
      <dispute-information
        v-if="currentSelectedTab === 'case'"
        ref="disputeInformation"
        :case-information="caseInformation" />
      <dispute-shipment-notes
        v-else-if="currentSelectedTab === 'shipment-notes'"
        ref="disputeShipmentNotes"
        :data="shipmentNotes" />
      <dispute-shipment-info
        v-else-if="currentSelectedTab === 'shipment-info'"
        ref="disputeShipmentInfo"
        :data="shipmentInfo" />
      <dnd-invoices
        v-else-if="currentSelectedTab === 'dnd-invoices'"
        :ohp-dispute-id="ohpDisputeId" />
      <disputed-charges
        v-else-if="currentSelectedTab === 'disputed-charges'"
        :case-details="caseDetails" />
      <auto-resolution-details
        v-else-if="currentSelectedTab === 'auto-resolution-details'"
        :selected-tab="selectedTab"
        :auto-resolution-details="autoResolutionDetails"
        :category="category"
        @redirectToSurchargeTab="redirectToSurchargeTab" />
      <!-- Gam Pahse Auto Changes -->
      <auto-gam-resolution-tab
        v-else-if="currentSelectedTab === 'auto-gam-resolution'"
        :gam-resolution-values="autoResolutionDetails"
        :is-gam-is-already-created="
          isGamIsAlreadyCreated || caseDetails?.disputeStage === 'Close'
        "
        :case-details="caseDetails"
        @showLoader="showLoader"
        @mountDetailsData="mountDetailsData"
        @hideLoader="hideLoader" />
      <dispute-attachments
        v-else-if="currentSelectedTab === 'attachments'"
        ref="disputeAttachments"
        :data="attachments"
        :ohp-dispute-id="ohpDisputeId"
        @updateAttachments="updateDisputeAttachments()" />
      <dispute-traces
        v-else-if="currentSelectedTab === 'dispute-traces'"
        ref="disputeTraces"
        :dispute-traces="disputeTraces"
        @startTracesPolling="startTracesPolling" />
      <dispute-with-voice
        v-else-if="currentSelectedTab === 'dispute-with-voice'"
        ref="dispute-with-voice"
        :data="voiceDisputes"
        :case-details="caseDetails"
        :disputes-constants="disputesConstants"
        :edit-history="voiceDisputesEditHistory"
        @createVoiceDisputes="createVoiceDisputes"
        @updateVoiceDispute="updateVoiceDispute"
        @deleteVoiceDispute="deleteVoiceDispute"
        @updateContactDetails="updateContactDetails"
        @getVoiceDisputeEditHistory="getVoiceDisputeEditHistory" />
      <dispute-activities
        v-else-if="currentSelectedTab === 'activities'"
        ref="disputeActivities"
        :user="user"
        :activities="activities"
        :case-details="caseDetails" />
      <surcharge-emails
        v-else-if="currentSelectedTab === 'surcharge-emails'"
        ref="surchargeEmails"
        :email-activities="surchargeEmails"
        :case-data="caseDetails"
        :current-skip-token="currentSkipToken"
        :selected-tab="selectedTab"
        :mail-id="clickedMailId"
        @clearViewMailId="clearViewMailId"
        @clearSkipToken="clearSkipToken"
        @showLoader="showLoader"
        @fetchSurchargeEmails="fetchSurchargeEmails"
        @hideLoader="hideLoader" />
    </div>

    <bulk-dispute-modal
      v-if="!isEmpty(bulkUpdatedId) || isBulkStatusModalVisible"
      :enable-search="isEmpty(bulkUpdatedId)"
      @onModalClose="$emit('toggleBulkStatusModal')">
    </bulk-dispute-modal>
  </div>
</template>

<script>
// Custom Components
import DisputeGridCard from "@/components/DisputeGridView/DisputeGridCard.vue";
import DisputeCaseInformation from "@/components/DisputeCaseInformation/DisputeCaseInformation.vue";
import DisputeInformation from "@/components/DisputeInformation/DisputeInformation.vue";
//import DisputeCaseDetails from "@/components/DisputeCaseDetails/DisputeCaseDetails.vue";
import DisputeComments from "@/components/DisputeComments/DisputeComments.vue";
import DisputeActivities from "@/components/DisputeActivities/DisputeActivities.vue";
import DisputeShipmentNotes from "@/components/DisputeShipmentNotes/DisputeShipmentNotes.vue";
import DisputeShipmentInfo from "@/components/DisputeShipmentInfo/DisputeShipmentInfo.vue";
import DisputedCharges from "@/components/DisputedCharges/DisputedCharges.vue";
import AutoResolutionDetails from "@/components/AutoResolutionDetails/AutoResolutionDetails.vue";
import AutoGamResolutionTab from "@/components/AutoGamResolution/Tab/AutoGamResolutionTab.vue";
import DndInvoices from "@/components/DndInvoices/DndInvoices.vue";
import DisputeAttachments from "@/components/DisputeAttachments/DisputeAttachments.vue";
import SurchargeEmails from "@/components/SurchargeEmails/SurchargeEmails.vue";
import DisputeWithVoice from "@/components/DisputeWithVoice/DisputeWithVoice.vue";
import DisputeTraces from "@/components/DisputeTraces/DisputeTraces.vue";
import DashboardSkeleton from "@/components/Skeleton/DashboardSkeleton";
import { showToast } from "@/components/common/Toast";
import Loading from "vue-loading-overlay";

// Constants
import {
  disputeDetailsCaseInformation,
  disputeCaseDetails,
  disputeShipmentNotes,
  disputeShipmentInformation,
} from "@/config/disputeDataConstant.js";

import { disputeStageMapping } from "@/config/disputeUpdateModalConstant.js";
import BulkDisputeModal from "@/components/BulkDisputeModal/BulkDisputeModal.vue";
import {
  detailsTabItems,
  invoiceBreakupColumns,
  lookUpParameters,
  disputeStatusList,
} from "@/config/constant.js";

// Actions
import { disputeActions, fileActions } from "@/actions";
import { gamActions } from "@/actions";

// Util
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import {
  getMsalIdToken,
  formatDate,
  resolutionDropdownFields,
  getCaseAging,
  debounce,
  isEmpty,
} from "@/utils/helpers";

export default {
  name: "Details",
  components: {
    DisputeActivities,
    DisputeAttachments,
    DisputeCaseInformation,
    DisputeInformation,
    //DisputeCaseDetails,
    DisputeComments,
    DisputeGridCard,
    DisputeShipmentNotes,
    DisputeShipmentInfo,
    DisputeTraces,
    DashboardSkeleton,
    DisputeWithVoice,
    Loading,
    DndInvoices,
    DisputedCharges,
    AutoResolutionDetails,
    BulkDisputeModal,
    SurchargeEmails,
    AutoGamResolutionTab,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    isBulkStatusModalVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
    bulkUpdatedId: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      ohpDisputeId: "",
      caseDetails: {},
      currentSelectedTab: "comments",
      caseInformation: {},
      loader: null,
      isInvoiceDetailsVisible: false,
      detailsTabItems,
      invoiceBreakup: [],
      caseDetailsSfdc: null,
      comments: {},
      activities: [],
      shipmentNotes: [],
      shipmentInfo: {},
      attachments: [],
      voiceDisputes: [],
      invoiceBreakupColumns,
      tableParentClass: "",
      disputeModalLoading: false,
      voiceDisputesEditHistory: [],
      disputeTraces: [],
      // Resolution props starts here
      lookUpParameters,
      resolutionRules: {},
      resolutionRulesLoading: false,
      resolutionModalLoading: false,
      resolutionStatusList: [],
      disputesConstants: {},
      disputeLookupFields: {},
      disputeDisputeChargecodeFields: {},
      resolutionStagesList: [],
      resolutionButtonValues: [],
      disputeStatusList: disputeStatusList,
      nextStatusDropDownList: [],
      pollingInterval: null,
      autoResolutionDetails: [],
      invoiceList: [],
      category: "",
      isSLAMissed: null,
      reasonForDelayOptions: [],
      surchargeEmails: [],
      currentSkipToken: "",
      isGamIsAlreadyCreated: false,
      sfdcCaseId: null,
      clickedMailId: [],
      aiAssistanceAlertVisible: true,
    };
  },
  computed: {
    isTracesPolling() {
      return this.currentSelectedTab === "dispute-traces";
    },
    detailsTabItemsList() {
      return this.detailsTabItems.filter((item) => item.id !== "dnd-invoices");
    },
    getInvoiceBaseAmount() {
      return this.invoiceList.length
        ? `${this.invoiceList[0]?.docCurrency} ${(
            +this.invoiceList[0]?.invoiceAmount || 0
          ).toFixed(2)}`
        : "";
    },
    getInvoicePayableAmount() {
      return this.invoiceList.length
        ? `${this.invoiceList[0]?.docCurrency} ${(
            +this.invoiceList[0]?.amountDoccur || 0
          ).toFixed(2)}`
        : "";
    },
  },

  created() {
    this.caseInformation = disputeDetailsCaseInformation;
    this.disputeCaseDetails = disputeCaseDetails;
    this.shipmentInfo = disputeShipmentInformation;
  },
  async mounted() {
    this.ohpDisputeId = this.$route.params.id;
    await this.fetchAllTheDisputeCaseDetails();
    if (
      !(
        (/^[59].*$/i.test(this.caseDetails?.invoiceNumber) &&
          this.caseDetails?.caseKey) ||
        !/^[59].*$/i.test(this.caseDetails?.invoiceNumber)
      )
    ) {
      this.detailsTabItems = this.detailsTabItems?.filter((item) => {
        return item?.id !== "auto-gam-resolution";
      });
    }
  },
  destroyed() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  methods: {
    isEmpty,
    async mountDetailsData() {
      await this.fetchAllTheDisputeCaseDetails();
    },
    clearSkipToken() {
      this.currentSkipToken = "";
      this.surchargeEmails = [];
    },
    showLoader(container) {
      this.loader = this.$loading.show({
        container: container ? this.$refs[container] : undefined,
        canCancel: false,
        onCancel: this.onCancel,
        color: "#0573ab",
        isFullPage: container ? false : true,
      });
    },
    hideLoader() {
      this.loader?.hide();
    },
    addParentClass(val) {
      this.tableParentClass = val;
    },
    async fetchDisputeDetails() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getDisputeDetailsById(
            this.ohpDisputeId,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.caseDetails = data;
        this.addCaseAging(data);
        // For updating the Case Information Tab
        this.caseInformation = {
          ...this.caseInformation,
          Booking_number: data.tpDocumentNumber,
          Brand: data.brand,
          Case_number: data.cmCaseNumber,
          Contact_name: data.contactPerson,
          Contact_email: data.contactEmail,
          Coordinator_code: data.coordinatorCode,
          Coordinator_function: data.coordinatorFunction,
          Charge_code: data.chargeCode,
          Currency: data.currency,
          Customer_name: data.customer,
          Area: data.areaName,
          Area_code: data.areaCode,
          Disputed_invoice_number: data.invoiceNumber,
          Disputed_amount: `${data.disputedAmount}`,
          Dispute_type: data.disputeType || "",
          GSC: data.gsc,
          Processor_name: data.processorName,
          Price_owner_name: data.priceOwnerName,
          Price_owner_code: data.priceOwnerScvCode,
          Reason: data.reasonDescription,
          Reason_code: data.reasonCode,
          Root_cause_code: data.rootCauseCode,
          Root_cause: data.rootCauseDescription,
          Region_code: data.regionCode,
          Region_name: data.regionName,
          Status_code: data.statusCode,
          Status_description: data.statusDescription,
          Fscm_created_at: data.fscmCreatedTs,
          Fscm_changed_at: data.fscmChangedTs,
          Team_leader: data.teamLeader,
          Payment_types: data.paymentType,
        };
      } catch (error) {
        console.error(error);
      }
    },
    async fetchDisputeShipmentInfo() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getShipmentDetailsForDisputeCaseById(
            this.ohpDisputeId,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        const parsedData = JSON.parse(data.details);
        this.shipmentInfo = {
          ...this.shipmentInfo,
          Booking_number: parsedData.booking_number,
          Brand_subsidiary: parsedData.brand_subsidiary,
          Shipping_status: parsedData.shipment_status,
          Booked_by_name: parsedData.booked_by_name,
          Booked_by_country: parsedData.booked_by_country,
          Consignee_country: parsedData.consignee_country,
          Consignee_name: parsedData.consignee_name,
          Origin: parsedData.origin_full,
          Destination: parsedData.destination_full,
          Picked_up_ffes: parsedData.booked_ffes,
          Latest_pcd: parsedData.latest_pcd,
          Destination_arrival_date:
            parsedData.destination_arrival_time_utc_expected,
          Shipper_name: parsedData.shipper_name,
          Shipper_scv_code: parsedData.shipper_scv_code,
          Shipper_country: parsedData.shipper_country,
        };
      } catch (error) {
        console.error(error);
      }
    },
    clearViewMailId() {
      this.selectedTab = "";
      this.mailId = [];
    },
    async fetchAutoResolutionInfo(hideLoader = true) {
      try {
        if (hideLoader) this.showLoader("tabContainer");
        let { data } = await AxiosFetchForMsal(
          disputeActions.getAutoResolutionDetails(
            this.caseDetails?.invoiceNumber,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        let autoAllocationList = [];
        this.invoiceList.length &&
          data?.forEach((element) => {
            if (element?.payload?.Details?.[0]?.charge_type) {
              const details = element.payload.Details.map((item) => {
                const invoiceData = (this.invoiceList || []).filter(
                  (invoice) => item.charge_type === invoice.chargeCode
                );
                return {
                  ...item,
                  chargeAmount: (invoiceData || [])
                    .map((data) => `${data?.currencyGcss} ${data?.amountGcss}`)
                    .join(", "),
                  expectedChargeAmount: (invoiceData || [])
                    .map((data) => `${data?.currencyGcss} 0`)
                    .join(", "),
                  algo_type: element.payload?.algo_type,
                  decision: "Potential Accept",
                  isPotentialAccept: true,
                };
              });
              this.category = element?.category;
              autoAllocationList = [...autoAllocationList, ...details];
            } else {
              const chargeType = element?.category?.split("-")?.[0]?.trim();
              const decision = element?.category?.split("-")?.[1]?.trim();
              const invoiceData = (this.invoiceList || []).filter(
                (invoice) =>
                  chargeType?.replaceAll("[Manual Charge]", "") ===
                  invoice.chargeCode
              );
              autoAllocationList.push({
                ...element?.payload,
                chargeAmount: (invoiceData || [])
                  .map((data) => `${data?.currencyGcss} ${data?.amountGcss}`)
                  .join(", "),
                expectedChargeAmount: (invoiceData || [])
                  .map((data) => `${data?.currencyGcss} 0`)
                  .join(", "),
                algo_type: element.payload?.algo_type,
                decision,
                charge_type: chargeType,
                expectedAmount: element?.payload?.expectedAmount
                  ? `$ ${element?.payload?.expectedAmount}`
                  : `$ 0`,
                justification: this.formJustification(
                  element?.payload?.Details
                ),
                expectedQuantity: element?.payload?.expectedQuantity,
                invoiceBaseRate: element?.payload?.invoiceBaseRate,
                invoiceQuantity: element?.payload?.invoiceQuantity,
                ...(this.extractMailId(
                  element?.payload?.Details,
                  "QSR Mail Ids"
                )?.length && {
                  qsr_mails: this.extractMailId(
                    element?.payload?.Details,
                    "QSR Mail Ids"
                  ),
                }),

                ...(this.extractMailId(
                  element?.payload?.Details,
                  "SFDC Case Numbers"
                )?.length && {
                  sfdc_mails: this.extractMailId(
                    element?.payload?.Details,
                    "SFDC Case Numbers"
                  ),
                }),
              });
            }
          });

        this.autoResolutionDetails = autoAllocationList;
        if (hideLoader) this.hideLoader();
      } catch (error) {
        console.error(error);
        this.autoResolutionDetails = [];
        this.category = "";
        if (hideLoader) this.hideLoader();
      }
    },
    async fetchSurchargeEmails(skipToken = "") {
      try {
        this?.hideLoader();
        this.showLoader("tabContainer");
        const { data } = await AxiosFetchForMsal(
          disputeActions.getEmailActivityContentFromQSR(
            this.caseDetails.tpDocumentNumber,
            `Bearer ${await getMsalIdToken(this)}`,
            skipToken
          )
        );
        this.surchargeEmails = data?.value || [];

        this.currentSkipToken = data?.["@odata.nextLink"]?.slice(
          data?.["@odata.nextLink"]?.lastIndexOf("skiptoken") +
            "skiptoken".length +
            1,
          data?.["@odata.nextLink"]?.length
        );
        this.hideLoader();
      } catch (error) {
        this.hideLoader();
      }
    },
    redirectToSurchargeTab(mailId, tab) {
      this.currentSelectedTab = "surcharge-emails";
      this.detailsTabItems = this.detailsTabItems?.map((item) => {
        return {
          ...item,
          active: item?.id == "surcharge-emails" ? true : false,
        };
      });
      this.selectedTab = tab;
      this.clickedMailId = mailId;
      this.fetchSurchargeEmails();
    },

    formJustification(details) {
      let justification = "";
      details?.forEach((item, index) => {
        Object.entries(item).forEach(([key, value]) => {
          if (key !== "QSR Mail Ids") {
            justification = `${justification}${!!index ? "\n\n" : ""}${key}\n${
              typeof value == "object" ? value?.join(", ") : value
            }`;
          }
        });
      });
      return justification;
    },
    extractMailId(details, mailKey) {
      let mailId = [];
      details?.forEach((item, index) => {
        Object.entries(item).forEach(([key, value]) => {
          if (key == mailKey) {
            mailId = value;
          }
        });
      });
      return mailId;
    },
    // Disupte Resolution methods starts here
    async fetchResolutionStageStatusList(selectedDispute, nextStage) {
      try {
        this.resolutionRulesLoading = true;
        let disputeStage = nextStage || selectedDispute?.disputeStage;
        if (!disputeStage) {
          disputeStageMapping &&
            Object.keys(disputeStageMapping).forEach((item) => {
              if (selectedDispute?.statusCode === item) {
                disputeStage = disputeStageMapping[item];
              }
            });
        }

        const { data } =
          disputeStage &&
          (await AxiosFetchForMsal(
            disputeActions.getDisputeResolutionStageList(
              await getMsalIdToken(this),
              disputeStage,
              selectedDispute?.isRedisputed || false
            )
          ));

        this.nextStatusDropDownList = data?.nextStatusDropDown?.length
          ? data?.nextStatusDropDown.filter(
              (item) =>
                item.id != 68 && item.id != 69 && item.id != 70 && item.id != 79
            )
          : [];
        let resolutionStatusList = this.nextStatusDropDownList?.length
          ? this.nextStatusDropDownList?.map((value) => {
              const statusDescription = value?.description;
              return {
                id: value?.id.toString(),
                value: statusDescription,
                label: statusDescription,
              };
            })
          : [
              {
                id: 2,
                label: `${selectedDispute?.statusCode}: ${selectedDispute?.statusDescription}`,
                value: `${selectedDispute?.statusCode}: ${selectedDispute?.statusDescription}`,
              },
            ];

        resolutionStatusList = [
          {
            id: "select",
            displayName: "Select",
            label: "Select",
            value: "",
          },
          ...resolutionStatusList,
        ];

        const resolutionStages = data?.disputeStageDropDown?.map((value) => {
          return {
            value: value,
            label: value,
          };
        });

        this.resolutionStatusList = resolutionStatusList;
        this.resolutionStagesList = !nextStage
          ? resolutionStages
          : this.resolutionStagesList;
        this.resolutionButtonValues = data?.buttonsDropDown;
        this.resolutionRulesLoading = false;
      } catch (error) {
        this.disputeModalType = "";
        showToast(
          "error",
          "Unable to fetch the dispute case details, Please try after sometime."
        );
        this.resolutionRulesLoading = false;
        console.error(error);
      }
    },
    async getCategoriesMenuItem() {
      try {
        this.resolutionRulesLoading = true;
        const { data } = await AxiosFetchForMsal(
          disputeActions.getCategoriesMenuItem(
            "reasonForDelayOptions",
            "Dispute",
            "Ocean",
            await getMsalIdToken(this)
          )
        );
        let reasonForDelayList = data
          ?.map((item) => {
            return {
              id: item?.itemValue?.replace(/\s+/g, " "),
              label: item?.itemValue?.replace(/\s+/g, " "),
              value: item?.itemValue?.replace(/\s+/g, " "),
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by 'label';
        this.reasonForDelayOptions = [
          {
            id: "select",
            label: "Select",
            value: "",
          },
          ...reasonForDelayList,
        ];
        this.resolutionRulesLoading = false;
      } catch (error) {
        this.disputeModalType = "";
        this.resolutionRulesLoading = false;
        console.error(
          "Unable to Fetch Reason ForDelayOptions. please try again"
        );
      }
    },
    async fetchDisputeResolutionRules(selectedDispute, nextStatus) {
      try {
        this.resolutionRulesLoading = true;
        const { data } = await AxiosFetchForMsal(
          disputeActions.getDisputeResolutionRules(
            await getMsalIdToken(this),
            selectedDispute?.statusCode,
            selectedDispute?.isRedisputed || false,
            nextStatus
          )
        );
        this.resolutionRules = data;
        this.resolutionRulesLoading = false;
      } catch (error) {
        this.resolutionRulesLoading = false;
        console.error(error);
      }
    },
    async isSLAMissedCheck(payload) {
      try {
        this.resolutionRulesLoading = true;
        const data = payload.selectedDispute;
        const bulkDisputeValidatePayload = data.map((item) => ({
          ohpDisputeId: item.ohpDisputeId,
          countryCode: item.countryCode,
          createdTs: item.createdTs,
          lastDisputedTs: item.lastDisputeTs,
          closedTs: item.closedTs,
          resolutionDelayReason: "Not Applicable",
          isDwV: item.isDwV || false,
        }));
        await AxiosFetchForMsal(
          disputeActions.validateBulkDispute(
            { data: bulkDisputeValidatePayload },
            await getMsalIdToken(this)
          )
        );
        this.isSLAMissed = false;
        this.resolutionRulesLoading = false;
      } catch (err) {
        this.isSLAMissed = true;
        this.resolutionRulesLoading = false;
      }
    },
    async fetchDisputeLookupFields() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.disputeFieldLookups(
            await getMsalIdToken(this),
            lookUpParameters
          )
        );
        this.disputeLookupFields = resolutionDropdownFields(data, false);
      } catch (error) {
        console.error(error);
      }
    },
    async fetchDisputeChargeCodeFields() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getChargeCodeDropdownValues(await getMsalIdToken(this))
        );
        this.disputeDisputeChargecodeFields = resolutionDropdownFields(
          data,
          false
        );
      } catch (err) {
        console.error(err);
      }
    },
    async fetchDisputeConstantFields() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.disputeFieldConstants(await getMsalIdToken(this))
        );
        this.disputesConstants = resolutionDropdownFields(data, true);
      } catch (error) {
        console.error(error);
      }
    },
    async getCaseDetailsInfo(selectedDispute) {
      this.resolutionModalLoading = true;
      await Promise.all([
        this.fetchDisputeResolutionRules(selectedDispute),
        this.fetchResolutionStageStatusList(selectedDispute),
        this.getCategoriesMenuItem(),
      ]).then(() => {
        this.resolutionModalLoading = false;
      });
    },
    getCaseDetailsStageStatusList(selectedDispute, nextStage) {
      this.fetchResolutionStageStatusList(selectedDispute, nextStage);
    },
    getCaseDetailsRulesList(selectedDispute, nextStatusId) {
      this.fetchDisputeResolutionRules(selectedDispute, nextStatusId);
    },
    // Disupte Resolution methods ends here

    // Get Dispute from SFDC by Invoice Number
    async fetchDisputeFromSfdc() {
      this.sfdcCaseId = (() => {
        try {
          return (
            JSON.parse(this.caseDetails?.sfdcCaseDetails)?.[0]?.caseId || null
          );
        } catch {
          return null;
        }
      })();
      console.log(
        "caseDetails",
        this.caseDetails,
        "sfdcCaseId",
        this.sfdcCaseId
      );
      try {
        this.showLoader("tabContainer");
        const { data } = await AxiosFetchForMsal(
          disputeActions.getDisputeFromSfdc(
            this.sfdcCaseId,
            `Bearer ${await getMsalIdToken(this)}`,
            this.caseDetails?.invoiceNumber
          )
        );
        // Handle both array and object responses from SFDC API
        this.caseDetailsSfdc = Array.isArray(data)
          ? data.length > 0
            ? data[0]
            : {}
          : data || {};
        this.hideLoader();
      } catch (error) {
        console.error(error);
        this.caseDetailsSfdc = {};
        this.hideLoader();
      }
    },
    async fetchRelatedIsrFromSfdc(dataLength, successCallback) {
      try {
        if (!dataLength) this.showLoader("tabContainer");
        const { data } = await AxiosFetchForMsal(
          disputeActions.getRelatedIsrFromSfdc(
            `Bearer ${await getMsalIdToken(this)}`,
            this.caseDetails?.invoiceNumber
          )
        );
        if (typeof successCallback === "function") {
          successCallback(data);
        }
        this.loader.hide();
      } catch (error) {
        console.error(error);
        this.loader.hide();
      }
    },
    //fetch ISR details
    async fetchISRDetails(id, successCallback) {
      try {
        this.showLoader("tabContainer");
        const { data } = await AxiosFetchForMsal(
          disputeActions.getIsrDetails(
            id,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (typeof successCallback === "function") {
          successCallback(data);
        }
        this.loader.hide();
      } catch (error) {
        console.error(error);
        this.loader.hide();
      }
    },
    async fetchAttachmentsFromSfdc(
      dataLength,
      id,
      successCallback,
      fullPageLoader
    ) {
      try {
        if (!dataLength)
          this.showLoader(!fullPageLoader ? "tabContainer" : null);
        const { data } = await AxiosFetchForMsal(
          disputeActions.getAttachmentsFromSfdc(
            this.sfdcCaseId,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (typeof successCallback === "function") {
          successCallback(data);
        }
        this.loader.hide();
      } catch (error) {
        console.error(error);
        this.loader.hide();
      }
    },
    // create ISR
    async createIsr(isrData, successCallback, errorCallback) {
      try {
        this.showLoader();
        const { data } = await AxiosFetchForMsal(
          disputeActions.createIsr(
            isrData,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.loader.hide();
        if (typeof successCallback === "function") {
          successCallback(data);
        }
        showToast("success", "ISR created successfully!");
      } catch (err) {
        this.loader.hide();
        if (typeof errorCallback === "function") {
          errorCallback(err?.response?.data?.errors || null);
        }
        showToast(
          "error",
          err?.response?.data?.message === "Bad Request" ||
            err?.response?.data?.message === "Bad_Request"
            ? "Please review the highlighted errors and try again!"
            : err?.response?.data?.message ||
                "Unable to create ISR, please try again!"
        );
        console.error(err);
      }
    },
    //Update Isr
    async updateIsr(id, updatedIsrData, successCallback, errorCallback) {
      try {
        this.showLoader();
        const { data } = await AxiosFetchForMsal(
          disputeActions.updateIsr(
            id,
            updatedIsrData,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.loader.hide();
        if (typeof successCallback === "function") {
          successCallback(data);
        }
        showToast("success", "ISR updated successfully!");
      } catch (err) {
        if (typeof errorCallback === "function") {
          errorCallback(err?.response?.data?.errors || null);
        }
        showToast(
          "error",
          err?.response?.data?.message === "Bad Request"
            ? "Please review the highlighted errors and try again!"
            : err?.response?.data?.message ||
                "Unable to update ISR, please try again!"
        );
        console.error(err);
        this.loader.hide();
      }
    },
    //fetch Country List
    getCountryList(searchTerm, callback) {
      if (
        searchTerm &&
        searchTerm.split("=")[1] &&
        searchTerm.split("=")[1].length >= 3
      ) {
        this.countryList(searchTerm, callback);
      }
    },
    countryList: debounce(async (searchTerm, callback) => {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getCountryList(searchTerm)
        );
        if (typeof callback === "function") {
          callback(data);
        }
      } catch (err) {
        console.error(err);
      }
    }, 350),
    // fetch email activities from sfdc
    async fetchEmailActivities(
      dataLength,
      id,
      successCallback,
      fullPageLoader
    ) {
      try {
        if (!dataLength)
          this.showLoader(!fullPageLoader ? "tabContainer" : null);
        const { data } = await AxiosFetchForMsal(
          disputeActions.getEmailActivities(
            this.sfdcCaseId,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (typeof successCallback === "function") {
          successCallback(data);
        }
        this.loader.hide();
      } catch (error) {
        console.error(error);
        this.loader.hide();
      }
    },
    async fetchInvoiceBreakUpDetails() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getDisputeInvoiceDetailsFromSap(
            await getMsalIdToken(this),
            this.caseDetails.invoiceNumber
          )
        );
        if (data && data.invoiceList) {
          const invoiceBreakupDataFromApi = data.invoiceList.map((item) => {
            return {
              charge_name: `${item.materialDescription} (${item.chargeCode})`,
              qty: `${(+item.quantity).toFixed(2)}`,
              uom: item.unitOfMeasure,
              rate: `${item.currencyGcss} ${(+item.baseRate).toFixed(2)}`,
              terms: item.terms,
              extendedValue: `${item.currencyGcss} ${(+item.amountGcss).toFixed(
                2
              )}`,
              billingDate: item.billingDate,
              invoiceDueDate: item.invoiceDueDate,
            };
          });
          this.invoiceBreakup = invoiceBreakupDataFromApi;
          this.invoiceList = data.invoiceList;
        }
      } catch (error) {
        this.loader.hide();
        console.error(error);
      }
    },
    async fetchDisputeActivities() {
      if (!this.activities.length) this.showLoader("tabContainer");
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getDisputeHistory(
            this.ohpDisputeId,
            `Bearer ${await getMsalIdToken(this)}`,
            "DISPUTE_ENTITY"
          )
        );
        this.activities = data;
        this.loader.hide();
      } catch (error) {
        console.error(error);
        this.loader.hide();
      }
    },
    async fetchDisputeAttachments() {
      try {
        this?.hideLoader();
        this.showLoader("tabContainer");
        const { data } = await AxiosFetchForMsal(
          fileActions.getAttachments(
            this.ohpDisputeId,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.attachments = data;
        this.hideLoader();
      } catch (error) {
        this.hideLoader();
      }
    },

    async updateDisputeAttachments() {
      await this.fetchDisputeAttachments();
    },
    async fetchDisputeComments(pageSize = 10, pageNo = 0) {
      if (pageNo !== 0) {
        this.showLoader("tabContainer");
      }
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.fetchComments(
            this.ohpDisputeId,
            `Bearer ${await getMsalIdToken(this)}`,
            pageSize,
            pageNo
          )
        );
        this.comments = data;
        if (pageNo !== 0) {
          this.loader.hide();
        }
      } catch (err) {
        if (pageNo !== 0) {
          this.loader.hide();
        }
        console.log(err);
      }
    },
    fetchDisputeShipmentNotes() {
      this.shipmentNotes = disputeShipmentNotes;
    },
    async fetchAllTheDisputeCaseDetails() {
      await Promise.all([
        this.fetchDisputeDetails().then(this.fetchInvoiceBreakUpDetails),
        this.fetchDisputeConstantFields(),
        this.fetchDisputeLookupFields(),
        this.fetchDisputeChargeCodeFields(),
        this.fetchDisputeComments(),
      ]);
    },
    async fetchVoiceDisputes(ohpDisputeId, successCallback) {
      try {
        const caseIdVal = ohpDisputeId || this.ohpDisputeId;
        const { data } = await AxiosFetchForMsal(
          disputeActions.getVoiceDisputes(
            caseIdVal,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (typeof successCallback === "function") {
          successCallback(data);
        }
        this.voiceDisputes = (data || []).sort(
          (a, b) => new Date(b.createdTs) - new Date(a.createdTs)
        );
      } catch (err) {
        console.log(err);
        this.voiceDisputes = [];
      }
    },
    async fetchDisputeTraces() {
      try {
        const {
          data: { disputeTraces },
        } = await AxiosFetchForMsal(
          disputeActions.getDisputeTraces(
            this.ohpDisputeId,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (disputeTraces) {
          const disputeTracesFromApi = disputeTraces.map(
            ({
              ohpDisputeTraceId,
              packet,
              createdTs,
              destination,
              status,
              retryCount,
              logs,
              workflowInstanceId,
            }) => {
              return {
                ohpDisputeTraceId,
                packet,
                createdTs: formatDate(createdTs),
                destination,
                status,
                retryCount: `${retryCount}`,
                logs: logs.replace(/\n|{|}/gi, "").trim(),
                workflowInstanceId: workflowInstanceId,
              };
            }
          );
          this.disputeTraces = disputeTracesFromApi;
        }
      } catch (err) {
        console.log(err);
        this.disputeTraces = [];
      }
    },
    getVoiceDisputeEditHistory(activeVoiceDispute) {
      this.fetchVoiceDisputeEditHistory(activeVoiceDispute?.ohpDisputeVoiceId);
    },
    async fetchVoiceDisputeEditHistory(voiceDisputeId) {
      this.showLoader();
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getDisputeHistory(
            voiceDisputeId,
            `Bearer ${await getMsalIdToken(this)}`,
            "DISPUTE_VOICE_ENTITY"
          )
        );
        this.voiceDisputesEditHistory = data;
        this.loader.hide();
      } catch (err) {
        console.log(err);
        this.voiceDisputesEditHistory = [];
        this.loader.hide();
      }
    },
    onTabActivated({ selectedItemId, updatedTabData }) {
      this.mailId = [];
      this.selectedTab = "";
      const tabDetails = {
        comments: () => {
          return this.fetchDisputeComments();
        },
        "case-information": () => {
          return this.fetchDisputeFromSfdc();
        },
        "shipment-info": () => {
          return this.fetchDisputeShipmentInfo();
        },
        "shipment-notes": () => {
          return this.fetchDisputeShipmentNotes();
        },
        attachments: () => {
          return this.fetchDisputeAttachments();
        },
        activities: () => {
          return this.fetchDisputeActivities();
        },
        "dispute-with-voice": () => {
          return this.fetchVoiceDisputes();
        },
        "dispute-traces": () => {
          return this.fetchDisputeTraces();
        },
        "auto-resolution-details": () => {
          return this.fetchAutoResolutionInfo();
        },
        "surcharge-emails": () => {
          return this.fetchSurchargeEmails();
        },
        "auto-gam-resolution": () => {
          return this.fetchAutoGamResolutionTabInfo();
        },
        default: () => {
          return;
        },
      };
      this.currentSelectedTab = selectedItemId;
      this.detailsTabItems = updatedTabData;
      (tabDetails[`${selectedItemId}`] || tabDetails["default"])();
    },
    handleInvoiceBreakupClick() {
      this.isInvoiceDetailsVisible = !this.isInvoiceDetailsVisible;
    },
    async updateCaseDetails() {
      await this.fetchDisputeDetails();
      await this.fetchDisputeActivities();
      await this.fetchDisputeComments();
    },
    async fetchGamInfoForInvoiceNumber() {
      try {
        let { data } = await AxiosFetchForMsal(
          gamActions.getGamInfoForInvoiceNumber(
            this.caseDetails?.invoiceNumber,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.isGamIsAlreadyCreated = data?.count ? true : false;
        if (this.isGamIsAlreadyCreated) {
          let autoResolutionData = this.autoResolutionDetails?.map((item) => {
            let temp = { ...item };
            data?.gamApproval?.forEach((gamItem) => {
              gamItem?.gamChargeItems?.forEach((chargeItems) => {
                if (
                  chargeItems?.billingDocumentNo ==
                    this.caseDetails?.invoiceNumber &&
                  item?.charge_type == chargeItems?.chargeCode
                ) {
                  temp = {
                    ...temp,
                    expectedAmount: chargeItems?.itemExpectedAmount?.toString(),
                    expectedQuantity:
                      chargeItems?.itemExpectedQuantity?.toString(),
                    invoiceBaseRate: chargeItems?.itemInvoiceAmount?.toString(),
                    invoiceQuantity: chargeItems?.itemQuantity?.toString(),
                  };
                }
              });
            });
            return temp;
          });
          this.autoResolutionDetails = autoResolutionData;
        }
      } catch (error) {}
    },
    async fetchAutoGamResolutionTabInfo() {
      this.showLoader("tabContainer");
      await Promise.all([await this.fetchAutoResolutionInfo(false)])
        .then(async () => {
          await this.fetchGamInfoForInvoiceNumber();
          this.hideLoader();
        })
        .catch((e) => {
          this.hideLoader();
        });
    },
    async updateDisputes() {
      this.showLoader();
      await this.fetchDisputeDetails();
      this.loader.hide();
    },
    async disputeStatusUpdate({ ohpDisputeId, status }) {
      this.showLoader();
      const selectedStatusCode = status.split(":")[0];
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.updateDisputeById(
            ohpDisputeId,
            {
              statusCode: selectedStatusCode,
            },
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (selectedStatusCode === data.statusCode) {
          this.caseDetails = data;
          await this.fetchDisputeActivities();
          showToast("success", "Status has been saved successfully!");
        } else {
          showToast("error", "Failed to updated the status, Please try again.");
        }
      } catch (error) {
        console.error(error);
        showToast("error", "Failed to updated the status, Please try again.");
      }
      this.loader.hide();
    },
    updateVoiceDisputeData() {
      this.fetchVoiceDisputes();
    },
    async createVoiceDisputes(voiceDisputeData, successCallback) {
      try {
        this.showLoader();
        const { data } = await AxiosFetchForMsal(
          disputeActions.createVoiceDisputes(
            this.ohpDisputeId,
            voiceDisputeData,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.updateVoiceDisputeData(data);
        if (typeof successCallback === "function") {
          successCallback();
        }
        showToast("success", "Voice dispute created successfully!");
      } catch (err) {
        showToast(
          "error",
          err?.response?.data?.message ||
            "Unable to create voice Dispute, please try again!"
        );
        console.error(err);
      }
      this.loader.hide();
    },
    async updateVoiceDispute(voiceDisputeData, successCallback) {
      try {
        this.showLoader();
        const { data } = await AxiosFetchForMsal(
          disputeActions.updateVoiceDispute(
            voiceDisputeData,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.updateVoiceDisputeData(data);
        if (typeof successCallback === "function") {
          successCallback();
        }
        showToast("success", "Voice dispute updated successfully!");
      } catch (err) {
        showToast(
          "error",
          err?.response?.data?.message ||
            "Unable to update voice Dispute, please try again!"
        );
        console.error(err);
      }
      this.loader.hide();
    },
    async deleteVoiceDispute(voiceDisputeData, successCallback) {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.deleteVoiceDispute(
            voiceDisputeData,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.updateVoiceDisputeData(data);
        if (typeof successCallback === "function") {
          successCallback();
        }
        showToast("success", "Voice dispute deleted successfully!");
      } catch (err) {
        showToast(
          "error",
          err?.response?.data?.message ||
            "Unable to delete voice Dispute, please try again!"
        );
        console.error(err);
      }
    },
    async updateContactDetails(contactDetails, successCallback) {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.updateContactDetails(
            this.ohpDisputeId,
            contactDetails,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.updateCaseDetails(data);
        if (typeof successCallback === "function") {
          successCallback();
        }
        showToast(
          "success",
          "Contact Details for dispute updated successfully!"
        );
      } catch (err) {
        showToast(
          "error",
          err?.response?.data?.message ||
            "Unable to update contact details for Dispute, please try again!"
        );
        console.error(err);
      }
    },
    addCaseAging(data) {
      this.caseDetails = {
        ...data,
        ...getCaseAging(data),
      };
    },
    startTracesPolling() {
      let interval = 5000;
      if (this.isTracesPolling && interval < 900000) {
        this.pollingInterval = setInterval(() => {
          this.fetchDisputeTraces();
          interval += interval;
          if (!this.isTracesPolling) {
            clearInterval(this.pollingInterval);
          }
        }, interval);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  width: 1280px;
  margin: 0 auto;
  margin-top: 80px;

  @media (min-width: 1400px) {
    padding: 1.5rem 0;
  }

  &-breadcrumb {
    margin-top: 0.5rem;

    &--nav {
      & a {
        color: var(--Blue-600-Dark);
      }
    }

    &--separator {
      margin: 0 0.5rem;
    }

    &--case-id {
      color: var(--Blue-900-Darkest);
    }
  }

  &-card {
    margin-top: 2rem;
  }

  &-invoice-breakup {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &-dropdown {
      display: flex;
      align-items: center;
      font-size: 1rem;

      &-name {
        font-family: "Maersk Text Bold";
        color: var(--Blue-600-Dark);
      }

      span {
        margin-left: 1rem;
        cursor: pointer;
      }
    }

    &-details {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;

      &-name {
        font-size: 1.25rem;
        color: var(--Blue-900-Darkest);
        margin-bottom: 1rem;
      }

      &-table {
        width: 100%;
      }
    }
  }

  &-tab-area {
    margin-top: 1.5rem;
  }
  &-sub-tabs {
    min-height: 120px;
    background: var(--Gray-50);
    border: 1px solid var(--Gray-100);
    box-shadow: 0px 1px 5px var(--black-variant-1),
      0px 3px 1px -2px var(--black-variant-1),
      0px 2px 2px var(--black-variant-1);
    padding: 1.5rem;
  }
  &__alert {
    background: var(--Warning-Light);
    display: block !important;
    position: relative;
    height: auto;
    padding: 4px 0;
    margin-bottom: 16px;
    & p {
      max-width: 1280px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      padding: 0 16px;
      & span {
        margin-left: 16px;
      }
    }
  }
}

.details--has-alert {
  .details-breadcrumb {
    margin-top: 0.5rem;
  }
}
</style>

<style lang="scss">
.details__wrapper {
  margin-bottom: 20px;
}
.details-invoice-breakup {
  .table-parent-style {
    overflow: auto;
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    ::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #f1f1f1;
    }
    ::-webkit-scrollbar-thumb {
      background: #888;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
}
</style>
